export const UPDATE_GENERAL_PROPS = "UPDATE_GENERAL_PROPS";
export const MERGE_GENERAL_PROPS = "MERGE_GENERAL_PROPS";
export const DELETE_GENERAL_PROPS = "DELETE_GENERAL_PROPS";
export const UPDATE_LOGIN_PROPS = "UPDATE_LOGIN_PROPS";
export const MERGE_LOGIN_PROPS = "MERGE_LOGIN_PROPS";
export const DELETE_LOGIN_PROPS = "DELETE_LOGIN_PROPS";
export const UPDATE_SHEDULE_BUILDER_PROPS = "UPDATE_SHEDULE_BUILDER_PROPS";
export const MERGE_SHEDULE_BUILDER_PROPS = "MERGE_SHEDULE_BUILDER_PROPS";
export const DELETE_SHEDULE_BUILDER_PROPS = "DELETE_SHEDULE_BUILDER_PROPS";
export const UPDATE_RESERVATION_PROPS = "UPDATE_RESERVATION_PROPS";
export const MERGE_RESERVATION_PROPS = "MERGE_RESERVATION_PROPS";
export const DELETE_RESERVATION_PROPS = "DELETE_RESERVATION_PROPS";
export const CLEAR_STATE = "CLEAR_STATE";
export const UPDATE_USER_PROPS = "UPDATE_USER_PROPS";
export const DELETE_USER_PROPS = "DELETE_USER_PROPS";
export const MERGE_USER_PROPS = "MERGE_USER_PROPS";
export const UPDATE_HOTEL_PROPS = "UPDATE_HOTEL_PROPS";
export const DELETE_HOTEL_PROPS = "DELETE_HOTEL_PROPS";
export const MERGE_HOTEL_PROPS = "MERGE_HOTEL_PROPS";
export const UPDATE_VENUE_PROPS = "UPDATE_VENUE_PROPS";
export const DELETE_VENUE_PROPS = "DELETE_VENUE_PROPS";
export const MERGE_VENUE_PROPS = "MERGE_VENUE_PROPS";
